import type { PluginObject } from 'vue';

import { SldsToast } from '@ui';

export function toast(
  message: string,
  props: Record<string, unknown> = {}
): void {
  const div = document.createElement('div');
  document.body.append(div);

  const instance = new SldsToast({
    propsData: { ...props, text: message, dismissible: true },
  }).$mount(div);

  instance.$on('close', () => {
    instance.$destroy();
    instance.$el.remove();
  });
}

const ToastPlugin: PluginObject<never> = {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$toast = toast;
  },
};

export default ToastPlugin;
